module.exports = __webpack_public_path__ + "img/img43.b6296103.jpg";